// Namespaces a per-setup localStorage key off a setup id. Split out from
// setups.js so state.js can build its own storage key without importing
// setups.js (which itself imports state.js's loadSetup) — keeps that
// relationship one-directional instead of circular.
export function scopedKey(base, setupId) {
  return `setup:${setupId}:${base}`;
}
